import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useLot = ({ handleMuestraSnack, setBotonSigDisabled }) => {
  const [ejecutaapi] = Api();
  const [lot, setLots] = useState([]);
  const usuario = localStorage.getItem("user");
  const [numlot, setNumLot] = useState(0);
  const [idLot, setIdLot] = useState();
  const [infolot, setInfoLot] = useState([]);
  const handleClickSave = (newData, type, idManzana) => {
    let body = {};
    let ejecuta = "";
    let mensaje = "";
    switch (type) {
      case "add":
        body = JSON.stringify({
          pidManzana: idManzana,
          pSuperficie: newData.SUPERFICIE,
          pTipo: newData.TIPO,
          pCosto: newData.COSTO,
          pcolindanciauno: newData.COLINDANCIA_UNO,
          pcolindanciados: newData.COLINDANCIA_DOS,
          pcolindanciatres: newData.COLINDANCIA_TRES,
          pcolindanciacuatro: newData.COLINDANCIA_CUATRO,
          usuario: JSON.parse(usuario).email
        });
        ejecuta = "insertalote";
        mensaje = "inserto";
        break;
      case "update":
        body = JSON.stringify({
          pIdLote: newData.ID_LOTE,
          pSuperficie: newData.SUPERFICIE,
          pTipo: newData.TIPO,
          pCosto: newData.COSTO,
          pcolindanciauno: newData.COLINDANCIA_UNO,
          pcolindanciados: newData.COLINDANCIA_DOS,
          pcolindanciatres: newData.COLINDANCIA_TRES,
          pcolindanciacuatro: newData.COLINDANCIA_CUATRO,
          usuario: JSON.parse(usuario).email
        });
        ejecuta = "actualizalote";
        mensaje = "actualizo";
        break;
      default:
        break;
    }

    ejecutaapi(ejecuta, body).then(data => {
      let { error } = ValidationResponse(data);
      if (error !== "") {
        handleMuestraSnack && handleMuestraSnack(error, "error");
      } else {
        handleMuestraSnack &&
          handleMuestraSnack("Se " + mensaje + " exitosamente", "success");

        getLots(idManzana);
      }
    });
  };

  const getLots = (idManzana, filtro) => {
    setLots([]);
    if (idManzana > 0) {
      let body = JSON.stringify({
        pIdManzana: idManzana,
        pfiltro: filtro ? 1 : 0,
        usuario: JSON.parse(usuario).email
      });
      ejecutaapi("obtienelotexmanzana", body).then(data => {
        let { result, error } = ValidationResponse(data);

        if (error !== "") handleMuestraSnack(error, "error");
        if (result.length > 0) setLots(result);
        if (result.length == 0 && filtro == 1)
          handleMuestraSnack(
            "No hay lotes disponibles para venta en esta manzana. Verifique que los lotes tengan precio y estatus disponible.",
            "warning"
          );
      });
    }
  };

  const handleInputSave = (e, idBlock, numlots) => {
    e.preventDefault();

    if (numlots === 0) {
      handleMuestraSnack("Debes insertar al menos un lote", "warning");
    } else {
      const body = JSON.stringify({
        pidManzana: idBlock,
        lotes: numlots,
        usuario: JSON.parse(usuario).email
      });
      ejecutaapi("insertamanzana", body).then(data => {
        let { error } = ValidationResponse(data);

        if (error !== "") {
          handleMuestraSnack && handleMuestraSnack(error, "error");
        } else {
          getLots(idBlock);
          handleMuestraSnack &&
            handleMuestraSnack(
              "Se insertaron los lotes exitosamente",
              "success"
            );
        }
      });
    }
  };

  const handleInput = value => {
    const newValue = Math.max(value, 0);
    setNumLot(newValue);
  };

  const onChangeLot = values => {
    //console.log("objeto lotes", lot);
    const info = lot.find(lot => lot.ID_LOTE === values); // lot.map(value => lot.find(lot => lot.ID_LOTE === value));
    setInfoLot(info);
    setIdLot(values);
    setBotonSigDisabled && setBotonSigDisabled(false);
  };

  const handleDeleteLot = (rowData, idManzana) => {
    const body = JSON.stringify({
      pIdLote: rowData.ID_LOTE,
      usuario: JSON.parse(usuario).email
    });
    return ejecutaapi("eliminalote", body).then(data => {
      if (data && data.Ok) {
        const rows = data.result[0];
        const r = Array.isArray(rows) ? rows[0] : rows;
        if (r && r.sResultado === 1) {
          handleMuestraSnack && handleMuestraSnack(r.sMensaje, "success");
          getLots(idManzana);
        } else if (r && r.sMensaje) {
          handleMuestraSnack && handleMuestraSnack(r.sMensaje, "warning");
        }
      } else {
        handleMuestraSnack && handleMuestraSnack("Error al eliminar lote", "error");
      }
    });
  };

  return {
    lot,
    handleClickSave,
    handleDeleteLot,
    getLots,
    numlot,
    handleInputSave,
    handleInput,
    idLot,
    onChangeLot,
    infolot
  };
};

export default useLot;
